import { RelativeWeekdays, Weekdays } from '../types'

const RELATIVE_DATE: Record<Weekdays, RelativeWeekdays> = {
  MONDAY: 'segunda-feira',
  TUESDAY: 'terça-feira',
  WEDNESDAY: 'quarta-feira',
  THURSDAY: 'quinta-feira',
  FRIDAY: 'sexta-feira',
  SATURDAY: 'sábado',
  SUNDAY: 'domingo',
}

export default RELATIVE_DATE
